import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';

export  interface IRegistration{
  policyid:number,
  policyname:string
}

@Injectable({
  providedIn: 'root'
})
export class TextBoxComponentsLibService {
  private _url: string = "http://localhost:8080/api/";

  constructor(private http:HttpClient) { }

  SaveRegistrations(formData:any):Observable<IRegistration>
  {
    return this.http.post<IRegistration>(this._url+"policies",formData);
  }

  getRegistrationsById(id:any):Observable<IRegistration>{
    return this.http.get<IRegistration>(this._url+id);
  }

  getDocument():Observable<IRegistration[]>{
    return this.http.get<IRegistration[]>("http://localhost:3000/api/find");
  }
}
